@if (!isFinished()) {
  <div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
      <a (click)="back()">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>
      <div class="p-2 flex-grow-1 pl-2">
        <h1 class="text-dark text-center">Califica tu experiencia</h1>
      </div>
    </div>

    <div>
      <div
        class="imgPerfil"
        [style.background-image]="'url(' + preview_img_avatar + ')'"
        style="background-position-x: center; background-position-y: center;"
      ></div>
      <div class="chkPerfil fade-in">
        <i class="bi bi-check-circle-fill" style="color: #205EA5;float:right;"></i>
      </div>
    </div>

    <div class="row-cols-12 m-2 mt-0">
      <div class="row-cols-12 mt-0">
        <div class="text-p p-3 pt-0 pb-0" style="font-weight: bold; font-size: 1.3em;">
          <hr style="width:20%;height: 5px;color: #CDCFD0;border-radius: 10px;margin: 0 auto;">
        </div>
      </div>

      <div class="row-cols-12 mt-0">
        <div class="text-p p-3 pb-1 nameUser">
          Turno #{{ id_orden_prestador }} con {{ nombre }}
        </div>
        <div class="text-p p-3 pt-0 locationUser">
          Califica la calidad del turno reservado siendo 1 la nota más baja y 10 la más alta
        </div>
      </div>

      <div class="row-cols-12 mt-0">
        <div class="row p-3 pb-0">
          <div class="col col-lg-10 fw-bold titleQuestion">
            ¿Cómo fue tu experencia con el profesional?
          </div>
        </div>

        <div class="row p-3 ps-3 pe-5 pb-0">
          @for (opcion of experiencias; track opcion.valor) {
            <div
              class="col-1"
              (mouseover)="hoverCalificacion(opcion.valor, 'experiencias')"
              (mouseout)="hoverCalificacion(0, 'experiencias')"
              (click)="calificarExpericencia(opcion.valor)"
            >
              <div
                class="border border-1 rounded-circle text-center optionCircle {{ opcion.class }}"
                [class.active]="opcion.active"
              >
                {{ opcion.valor }}
              </div>
            </div>
          }
        </div>
      </div>

      <div class="row-cols-12 mt-0">
        <div class="row p-3 pb-0">
          <div class="col col-lg-10 fw-bold titleQuestion">
            ¿Qué tan puntual fue tu turno?
          </div>
        </div>

        <div class="row p-3 ps-3 pe-5 pb-0">
          @for (opcion of preguntas_2; track opcion.valor) {
            <div
              class="col-1"
              (mouseover)="hoverCalificacion(opcion.valor, 'preguntas_2')"
              (mouseout)="hoverCalificacion(0, 'preguntas_2')"
              (click)="calificarPregunta2(opcion.valor)"
            >
              <div
                class="border border-1 rounded-circle text-center optionCircle {{ opcion.class }}"
                [class.active]="opcion.active"
              >
                {{ opcion.valor }}
              </div>
            </div>
          }
        </div>
      </div>

      <div class="row-cols-12 mt-0">
        <div class="row p-3 pb-0">
          <div class="col col-lg-10 fw-bold titleQuestion">
            ¿Algo que quieras agregar?
          </div>
        </div>
        <div class="row p-4 pb-0">
          <textarea
            class="add-notes"
            [(ngModel)]="x_comentario"
            name="x_comentario"
            rows="2"
            [readOnly]="!!calificacionOrdenPrestador"
          ></textarea>
        </div>
      </div>
    </div>

    @if (error()) {
      <div class="alert alert-danger mt-2" role="alert">
        <small>{{ error() }}</small>
      </div>
    }

    @if (!calificacionOrdenPrestador) {
      <div class="d-grid mt-4 mb-2">
        <button
          type="button"
          class="btn btn-primary btn-lg mt-0"
          [disabled]="loadingLocal() || loadingGlobal()"
          (click)="finalizaReviewPrestador()"
        >
          {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : 'Calificar' }}
        </button>
      </div>
    }
  </div>
} @else {
  <div class="container mt-5 fade-in-left" id="centerFrameTwo">
    <div class="row p-3 mb-3 mt-5 align-items-center">
      <div class="mt-5">
        <div class="row form-switch ps-0 mb-3">
          <div class="col text-center sucess-text mt-5 mb-5">
            <b>¡Tu review del prestador<br><span class="bluetext"><strong>fue enviada!</strong></span></b>
          </div>
        </div>
      </div>

      <div class="d-grid mt-3 mb-3 pb-3">
        <button [routerLink]="['/dashboard']" type="button" class="btn btn-primary btn-lg mt-0">
          Volver
        </button>
      </div>
    </div>
  </div>
}